<script>
  import {onMount, onDestroy} from "svelte";
  import {redirectToPage, getApiUrl} from "./util";
  import {user} from "./stores";
  import InputField from "./components/InputField.svelte";
  import SubmitButton from "./components/SubmitButton.svelte";

  let isSignUp = false;
  let isResetPassword = false;
  let isLoading = false;

  let token = new URLSearchParams(window.location.search).get("token");
  let userid = token.split("~")[0];
  token = token.split("~")[1];
  console.debug(token);
  console.debug(userid);

  let username = "";
  $: {
    username = $user.username? $user.username : "";
    console.debug("username: ", username);
  }
  let password = "";
  let email = "";
  let passwordConfirm = "";

  let successMsg = "";
  let errMsg = "";
  let errMsgs = {};

  function setErrMsgs(field = null, msg = "", msgTop = undefined) {
    successMsg = null;
    if (msgTop !== undefined) {
      errMsg = msgTop;
    }
    if (field === null) {
      for (const key in errMsgs) {
        errMsgs[key] = null;
      }
      return;
    } else {
      errMsgs[field] = msg;
    }
  }

  function handleInput(field) {
    return () => {
      successMsg = null;
      setErrMsgs(field, "", "");
    };
  }

  async function handleErrors(res) {
    const {errors, error} = await res.json();
    if (errors || error) {
      const errorArr = errors ? errors : [{msgTop: error}];
      console.debug(errorArr);
      setErrMsgs(null, "", "");
      errorArr.forEach(({field, msg, msgTop}) => {
        setErrMsgs(field, msg, msgTop);
      });
    }
  }

  async function validateToken() {
    isLoading = true;
    try {
      const res = await fetch(getApiUrl("validate-token", null, "users/verify"), {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({userid, token})
      });
      if (res.ok) {
        const data = await res.json();
        const {purpose, username} = data;
        console.debug(purpose);
        user.update((user) => {
          return {...user, username};
        });
        if (purpose === "signup") {
          isSignUp = true;
        } else if (purpose === "reset_password") {
          isResetPassword = true;
        }
      } else {
        handleErrors(res);
      }
    } catch (err) {
      errMsg = err.message;
    } finally {
      isLoading = false;
    }
  }

  async function handleResetPassword() {
    console.debug("handleResetPassword()");
    console.debug({password, passwordConfirm});
    isLoading = true;

    if (password !== passwordConfirm) {
      errMsgs.passwordConfirm = "Passwords do not match";
      isLoading = false;
      return;
    }
    const res = await fetch(getApiUrl("reset-password", null, "users"), {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({password, userid, token})
    });
    isLoading = false;
    if (res.ok) {
      const data = await res.json();
      console.debug(data);
      successMsg = "Password reset successfully";
      user.update((user) => {
        return {...user, username: username};
      });
      redirectToPage("login");
    } else {
      handleErrors(res);
    }
  }

  async function compSignUp(event) {
    event.preventDefault();
    redirectToPage("login");
  }

  onMount(() => {
    document.querySelector("header").style.display = "none";
    validateToken();
  });
  onDestroy(() => {
    document.querySelector("header").style.display = "flex";
  });
</script>

<header>
  FDMF Error Management

  <button class="btn btn-link" on:click={() => redirectToPage("login")}> Login </button>
</header>

<main class="login-container">
  <div class="card">
    <nav>
      <ul>
        <li class="tab-active">
          {isResetPassword ? "Reset Password" : "Verification"}
        </li>
      </ul>
    </nav>
    {#if errMsg || successMsg}
      <div class={errMsg ? "error-message" : "success-message"}>
        {errMsg ? errMsg : successMsg}
      </div>
    {/if}

    {#if !isSignUp && !isResetPassword}
      {#if isLoading}
        <span class="spinner" />
      {/if}
    {/if}

    {#if isSignUp}
      <form on:submit={compSignUp}>
        <p>
          Hi {username}! Thank you for signing up. Please return to the login page and sign in.
        </p>
        <SubmitButton {isLoading} label="Sign in" />
      </form>
    {/if}

    {#if isResetPassword}
      <form on:submit|preventDefault={handleResetPassword}>
        <InputField label={"Username"} id="username" bind:value={username} {handleInput} {errMsgs} />

        <InputField label={"Password"} id="password" bind:value={password} {handleInput} {errMsgs} />

        <InputField label={"Confirm Password"} id="passwordConfirm" bind:value={passwordConfirm} {handleInput} {errMsgs} />

        <SubmitButton {isLoading} label="Reset Password" />
      </form>
    {/if}
  </div>
</main>

<style>
  header {
    position: fixed;
    color: #111;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    justify-content: space-between;
    background-color: var(--color-surface);
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    padding: 1.5rem;
    font-size: 2em;
    font-weight: 600;
    color: #555;
    z-index: 1 !important;
  }
  .card {
    min-height: 200px;
  }
  .card nav {
    margin: 0;
  }
  .card nav ul {
    justify-content: center;
  }
  .card nav ul li {
    width: 10rem;
  }
  .spinner {
    display: block;
    margin: 4em auto;
  }

  header button {
    float: right;
    margin: 0 0.8em;
    border: none;
    border-radius: 4px;
    padding: 0.7em 1em;
    font-size: 0.6em;
    color: #fff;
    background-color: #2196f3;
  }
</style>
